import { JSONInterface } from 'Interfaces/JsonInterface';
import { getRequestConfig } from '../api';

export const getAIUsage = () => {
  return new Promise<JSONInterface>((resolve, reject) => {
    const headers = getRequestConfig();
    const data = { ...headers };

    fetch('/json/admin/getAiUsage', data).then(res => res.json()).then(json => {
      resolve(json);
    }).catch(e => {
      reject(e);
    });
  });
};

export const getDetailedAiUsage = () => {
  return new Promise<JSONInterface>((resolve, reject) => {
    const headers = getRequestConfig();
    const data = { ...headers };

    fetch('/json/admin/getDetailedAiUsage', data).then(res => res.json()).then(json => {
      resolve(json);
    }).catch(e => {
      reject(e);
    });
  });
};
